import React from 'react'
import { Briefcase, User } from 'lucide-react';
import { MetricGrid, MetricCard, ActivityChart, C } from './AdminAnalyticsUI';

function AnalyticLoginCard({totalCount, xAxisValues, values, rangeLabel}) {
  return (
    <div className='flex flex-col w-full font-plexsans'>
      <MetricGrid cols={2}>
        <MetricCard
          icon={<Briefcase size={16} strokeWidth={2} color={C.brass} />}
          tile="rgba(138,98,49,.1)"
          title="Professional logins"
          value={totalCount?.professional}
          desc="Successful sign-ins by attorneys, firms and funders"
        />
        <MetricCard
          icon={<User size={16} strokeWidth={2} color={C.green} />}
          tile="rgba(58,125,79,.1)"
          title="Client logins"
          value={totalCount?.client}
          desc="Successful sign-ins by clients"
        />
      </MetricGrid>
      <ActivityChart
        title="Logins over time"
        xAxisValues={xAxisValues}
        rangeLabel={rangeLabel}
        series={[
          { label: 'Professional logins', color: C.brass, data: values?.professional },
          { label: 'Client logins', color: C.green, data: values?.client },
        ]}
      />
    </div>
  )
}

export default AnalyticLoginCard
